import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

function ColorBox({ labelSide, hue, sat, lit }) {
  return (
    <BoxWrapper
      style={{
        flexDirection:
          labelSide === 'above' ? 'column' : 'column-reverse',
      }}
    >
      <Channels>
        <Row>
          <Key>HUE:</Key> {hue}
        </Row>
        <Row>
          <Key>SAT:</Key> {sat}
        </Row>
        <Row>
          <Key>LIT:</Key> {lit}
        </Row>
      </Channels>
      <Box
        style={{ backgroundColor: `hsl(${hue}deg ${sat}% ${lit}%)` }}
      />
    </BoxWrapper>
  );
}

function HSLColors({ labelSide = 'above' }) {
  return (
    <Wrapper>
      <ColorBox labelSide={labelSide} hue={60} sat={100} lit={50} />
      <ColorBox labelSide={labelSide} hue={240} sat={100} lit={50} />
    </Wrapper>
  );
}

const BREAKPOINT = 500;

const Wrapper = styled.div`
  display: flex;
  gap: 32px;
  padding: 0 32px;
  justify-content: center;
  width: 100%;

  @media ${BREAKPOINTS.smAndSmaller} {
    gap: 16px;
    padding: 0;
  }
`;

const BoxWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 200px;
`;

const Box = styled.div`
  width: 100%;
  min-height: 40px;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
`;

const Channels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-family: var(--font-family-mono);
  padding: 0px 8px;
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
`;

const Key = styled.div`
  font-weight: var(--font-weight-medium);
`;

export default HSLColors;
